<template>

    <div id="sidebar" v-if="user">

        <v-the-menu />

        <div class="sidebar-body">
            <div v-if="project" class="nav">
                <router-link v-if="!company.onboarded" class="nav-link accent" :to="{ name: 'install' }" :class="{ active: $route.name === 'install' }">Getting Started 👋</router-link>
                <router-link class="nav-link" :to="{ name: 'projects' }" :class="{ active: $route.name === 'projects' }">
                    <span><i class="icon fas fa-folder-tree"></i>Projects</span>
                </router-link>
                <div class="nav-group" :class="{ active: $route.name.match('(customer|customers|events|exports|segments|tags|traits).*') }">
                    <router-link class="nav-link" :to="{ name: 'customers' }">
                        <span><i class="icon fas fa-id-card"></i>Platform</span>
                    </router-link>
                    <div class="nav-group-items">
                        <router-link class="nav-link" :to="{ name: 'customers' }" :class="{ active: $route.name.startsWith('customer') }">Customers</router-link>
                        <router-link class="nav-link" :to="{ name: 'segments' }" :class="{ active: $route.name.startsWith('segments') }">Segments</router-link>
                        <router-link class="nav-link" :to="{ name: 'traits' }" :class="{ active: $route.name.startsWith('traits') }">Traits</router-link>
                        <router-link class="nav-link" :to="{ name: 'events' }" :class="{ active: $route.name.startsWith('events') }">Events</router-link>
                        <router-link class="nav-link" :to="{ name: 'tags' }" :class="{ active: $route.name.startsWith('tags') }">Tags</router-link>
                        <router-link class="nav-link" :to="{ name: 'exports' }" :class="{ active: $route.name.startsWith('exports') }">Exports</router-link>
                    </div>
                </div>
                <router-link class="nav-link" :to="{ name: 'automations' }" :class="{ active: $route.name.startsWith('automations') }">
                    <span><i class="icon fas fa-paper-plane"></i>Automations</span>
                </router-link>
                <router-link class="nav-link" :to="{ name: 'broadcasts' }" :class="{ active: $route.name.startsWith('broadcasts') }">
                    <span><i class="icon fas fa-envelope"></i>Broadcasts</span>
                </router-link>
                <router-link class="nav-link" :to="{ name: 'templates' }" :class="{ active: $route.name.startsWith('templates') }">
                    <span><i class="icon fas fa-envelope-open-text"></i>Templates</span>
                </router-link>
                <router-link class="nav-link" :to="{ name: 'forms' }" :class="{ active: $route.name.startsWith('forms') }">
                    <span><i class="icon fas fa-pen-to-square"></i>Forms</span>
                </router-link>
                <router-link class="nav-link" :to="{ name: 'settings' }" :class="{ active: $route.name.startsWith('settings') }">
                    <span><i class="icon fas fa-toolbox"></i>Settings</span>
                </router-link>
                <div class="nav-divider"></div>
                <v-usage-meter />
                <div class="nav-divider"></div>
                <a class="nav-link" href="#" @click.prevent="$store.commit('showModal', 'feedback')">
                    <span>Request Feature</span><i class="arrow fas fa-external-link-alt"></i>
                </a>
                <a class="nav-link" href="https://docs.crowdpower.io" target="_blank">
                    <span>Docs</span><i class="arrow fas fa-external-link-alt"></i>
                </a>
                <a class="nav-link" href="https://documenter.getpostman.com/view/17896162/UV5TFKbh" target="_blank">
                    <span>REST API</span><i class="arrow fas fa-external-link-alt"></i>
                </a>
                <a class="nav-link" href="https://saastic.com/?ref=crowdpower" target="_blank">
                    <span>Try Saastic</span><i class="arrow fas fa-external-link-alt"></i>
                </a>
            </div>
            <div v-else class="nav">
                <router-link class="nav-link" :to="{ name: 'projects' }" :class="{ active: $route.name === 'projects' }">Projects</router-link>
            </div>
        </div>

        <router-link class="sidebar-footer" :to="{ name: 'console' }" >
            <img src="/img/crowdpower-logo-white.svg" height="20" width="auto" />
        </router-link>

    </div>

</template>

<style scoped lang="scss">

    #sidebar {

        @include scrollbar(3px, $color-rule, transparent);
        background: $color-sidebar;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        height: 100%;
        left: 0;
        top: 0;
        transition: .3s background-color;
        width: $sidebar-width;
        z-index: 1;

        .sidebar-body {
            -webkit-overflow-scrolling: touch;
            flex-grow: 1;
            overflow-y: auto;
            padding: 0 0 60px 0;
        }

        .sidebar-footer {
            align-items: center;
            display: flex;
            justify-content: center;
            padding: 30px 0;
            transition: opacity .3s;
            &:hover {
                opacity: 0.7;
            }
        }

        .nav {
            margin: 0;
            padding: 15px 0;
            .nav-link {
                @include font-medium(13px);
                align-items: center;
                border-left: 3px solid transparent;
                box-sizing: border-box;
                color: #fff;
                display: flex;
                justify-content: space-between;
                line-height: 32px;
                margin: 0;
                opacity: 0.8;
                padding: 0 15px 0 12px;
                text-decoration: none;
                transition: opacity .3s;
                user-select: none;
                width: 100%;
                &:hover {
                    opacity: 1;
                }
                &.active {
                    border-left-color: $color-primary !important;
                    opacity: 1;
                }
                &.accent {
                    color: $color-success;
                    &.active {
                        border-left-color: $color-success !important;
                    }
                }
                .icon {
                    margin-right: 5px;
                    width: 20px;
                }
                .arrow {
                    opacity: 0.5;
                }
            }
            .nav-group {
                width: 100%;
                &.active {
                    .nav-link:first-child {
                        border-left-color: $color-primary;
                    }
                    .nav-group-items {
                        display: block;
                        .nav-link {
                            border-left-color: #fff;
                            padding-left: 37px;
                        }
                    }
                }
                .nav-group-items {
                    display: none;
                }
            }
            .nav-divider {
                background: rgba(255,255,255,0.1);
                height: 1px;
                margin: 15px 0;
                width: 100%;
            }
        }

        @media (min-width: $screen-xl-min) {
            position: fixed;
        }
    }

</style>

<script>

import TheMenu from '@cmp/TheMenu';

export default {

    components: {
        'v-the-menu': TheMenu,
    },

    data() {
        return {
            showAccountMenu: false
        }
    },

    computed: {

        user() {
            return this.$store.getters.user;
        },

        company() {
            return this.$store.getters.company;
        },

    },

}

</script>
